// This React component, `InterestFreeCreditPage`, is a Next.js client component that renders an interest-free credit landing page.
// It retrieves data from the `dataSource` within the provided `data` prop and passes it to the `InterestFreeCredit` component for
// display. The component ensures type safety by using the `TasticProps` type. This setup helps in managing and rendering dynamic
// content efficiently.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import { InterestFreeCreditPageProps } from 'types/next';
import InterestFreeCredit from 'components/commercetools-ui/organisms/landing-pages/interest-free-credit';

const InterestFreeCreditPage = ({ data }: TasticProps<InterestFreeCreditPageProps>) => {
  const contentData = data?.data?.dataSource;

  return (
    <>
      <InterestFreeCredit interestFreeCredit={contentData} />
    </>
  );
};

export default InterestFreeCreditPage;
